import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Scheduler from './components/Scheduler';
import IconShowcase from './components/IconShowcase';
import Loading from './components/Loading';
import Error from './components/Error';
import { BrandingProvider, useBranding } from './contexts/BrandingContext';
import { CalendarProvider, useCalendar } from './contexts/CalendarContext';
import { SessionProvider, useSession } from './contexts/SessionContext';
import { LeadSalvageProvider } from './contexts/LeadSalvageContext';


function CalendarWidget() {
  const { 
    loading, 
    error, 
    closeWidget, 
    handleBackgroundClick 
  } = useCalendar();
  
  const { variant } = useBranding();
  const { sessionLoading } = useSession();

  if (loading || sessionLoading) {
    return <Loading />;
  }

  if (error) {
    return <Error error={error} onClose={closeWidget} onBackgroundClick={handleBackgroundClick} />;
  }

  return (
    <div className={`App widget-${variant}`} onClick={handleBackgroundClick}>
      <Scheduler />
    </div>
  );
}

function CalendarWidgetWrapper() {
  return (
    <CalendarProvider>
      <SessionProvider>
        {/* CIN-6274: LeadSalvageProvider must sit INSIDE SessionProvider so it
            can read session state (personalInfo/currentStep/schedule) for the
            salvage decision. It renders the salvage modal and owns attemptClose. */}
        <LeadSalvageProvider>
          <CalendarWidget />
        </LeadSalvageProvider>
      </SessionProvider>
    </CalendarProvider>
  );
}

function App() {
  return (
    <BrandingProvider>
      <Routes>
        <Route path="/icons" element={<IconShowcase />} />
        <Route path="/:calendarId" element={<CalendarWidgetWrapper />} />
        <Route path="/" element={<CalendarWidgetWrapper />} />
      </Routes>
    </BrandingProvider>
  );
}

export default App;
